import React from 'react'
import { useEffect } from 'sb-hooks'
import { constants, sentry } from 'common/helpers'
import { Message } from 'sb-react-intl'

import composeDialogModal from 'components/modals/DialogModal/composeDialogModal'

import messages from './messages'
import s from './SomethingWentWrongModal.scss'


const SomethingWentWrongModal = composeDialogModal({
  name: constants.modals.SomethingWentWrong,
  title: messages.title,
  buttonTitle: messages.buttonTitle,
  content: () => (
    <div className={s.content} data-testid={constants.testIds.modal.somethingWentWrongModal}>
      <Message text={messages.text} html />
    </div>
  ),
})

const SomethingWentWrongModalWrapper = (props) => {
  const { data } = props

  useEffect(() => {
    const { statusCode, body } = data

    const isTerminated = statusCode === undefined && body === undefined

    if (!isTerminated && statusCode !== 502) {
      const title = `Something went wrong${statusCode >= 500 ? ` ${statusCode}` : ''}`

      sentry.captureMessage(title, {
        extra: data,
      })
    }
  }, [ data ])

  return (
    <SomethingWentWrongModal {...props} />
  )
}


export default SomethingWentWrongModalWrapper
